
function transformSpaces(input: string) {
  return input.replace(' ', '%20');
}

export {transformSpaces}
